goog.provide("shadow.js.shim.module$react_use$lib$useMedia$default");
shadow.js.shim.module$react_use$lib$useMedia$default = shadow.js.shim.module$react_use$lib$useMedia.default;
